<template>
    <b-modal
        id="modalDataDiagnostic"
        :hide-footer="true"
        title="New Data Diagnostic!"
        @show="load">
    <b-container>
      <div v-show="!isShowSuccess">
        <div class="col-sm-12" style="padding-left: 0; padding-right: 0;">
          <b-form-group>
            <b-form-input placeholder="First Name *" :state="this.infoValid.fname.state" v-model="info.fname"/>
            <span v-if="infoValid.fname.text" class="text-danger">{{infoValid.fname.text}}</span>
          </b-form-group>
          <b-form-group>
            <b-form-input placeholder="Last Name *" :state="this.infoValid.lname.state" v-model="info.lname"/>
            <span v-if="infoValid.lname.text" class="text-danger">{{infoValid.lname.text}}</span>
          </b-form-group>
          <b-form-group>
            <b-form-input placeholder="Company Name" v-model="info.company"/>
          </b-form-group>
          <b-form-group>
            <b-form-input placeholder="Email Address *" :state="this.infoValid.email.state" type="email" v-model="info.email"/>
            <span v-if="infoValid.email.text" class="text-danger">{{infoValid.email.text}}</span>
          </b-form-group>
          <b-form-group>
            <b-form-input placeholder="Qty of Records in Database" v-model="info.qty"/>
          </b-form-group>
          <b-form-group>
            <b-form-textarea :rows="3" placeholder="Questions/Comments *" :state="this.infoValid.message.state" v-model="info.message"/>
            <span v-if="infoValid.message.text" class="text-danger">{{infoValid.message.text}}</span>
          </b-form-group>
          <div class="form-group" style="text-align: left;font-size: 12px;">
            <label><i>* Required</i></label>
          </div>
        </div>
        <div class="col-sm-5" style="padding-left: 0; padding-right: 0;"></div>

        <b-row>
          <div class="col-sm-7">
            <b-col class="colcenter">
              <b-btn :disabled="btnDisable" @click="submit">CONTACT US</b-btn>
            </b-col>
          </div>
        </b-row>
      </div>
      <div v-show="isShowSuccess" class="colcenter">
        <b-row>
          <b-col>
            <h1>Thanks for contacting us!</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h3>We will get back to you very soon.</h3>
          </b-col>
        </b-row>
      </div>
    </b-container>
    </b-modal>
</template>

<script>
  import notification from '@/components/common/notification'

  export default {
    data () {
      return {
        info: {
          fname: '',
          lname: '',
          company: '',
          email: '',
          qty: '',
          message: ''
        },
        btnDisable: false,
        infoValid: {
          fname: {
            state: null,
            text: ''
          },
          lname: {
            state: null,
            text: ''
          },
          email: {
            state: null,
            text: ''
          },
          message: {
            state: null,
            text: ''
          }
        },
        isShowSuccess: false
      }
    },
    methods: {
      submit () {
        this.clearValid(this.infoValid)
        let that = this
        if (this.validInfo()) {
          this.btnDisable = true
          this.$http.post(this.$store.getters['config/link']('sendMessage'), {
            Action: 'save-contact-info',
            FormData: JSON.stringify({
              FirstName: this.info.fname,
              LastName: this.info.lname,
              Company: this.info.company,
              Email: this.info.email,
              Phone: '',
              Comment: this.info.message,
              Page: this.info.qty,
              PageInfo: window.location.hostname === 'dev.sl360.com' ? '[Staging]Landing Page Data Diagnostic Inquiry' : 'Landing Page Data Diagnostic Inquiry',
              FromSite: 'sl360.com',
              Source: 'LandingPage-Data-Diagnostic'
            })
          }, {
            emulateJSON: true
          }).then(resp => {
            that.btnDisable = false
            if (resp.body.Status === 1) {
              that.isShowSuccess = true
              // notification.notice('error', 'Failed to sent contact information , please try again')
            }
          }, resp => {
            notification.notice('error', 'Failed to sent contact information , please try again')
            this.btnDisable = false
          })
        }
      },
      showDemo () {
        window.open('/DHA_v7.pdf')
      },
      validInfo () {
        let isValid = true
        if (!this.info.fname) {
          this.infoValid.fname.state = false
          this.infoValid.fname.text = "It's required"
          isValid = false
        }
        if (!this.info.lname) {
          this.infoValid.lname.state = false
          this.infoValid.lname.text = "It's required"
          isValid = false
        }
        if (!(this.info.email.indexOf('@') > 0 && this.info.email.indexOf('@') < this.info.email.length - 1)) {
          this.infoValid.email.state = false
          this.infoValid.email.text = 'E-mail must be valid'
          isValid = false
        }
        if (!this.info.email) {
          this.infoValid.email.state = false
          this.infoValid.email.text = "It's required"
          isValid = false
        }
        if (!this.info.message) {
          this.infoValid.message.state = false
          this.infoValid.message.text = "It's required"
          isValid = false
        }
        return isValid
      },
      clearValid (items) {
        for (let key in items) {
          items[key].state = null
          items[key].text = false
        }
      },
      load () {
        this.info.fname = this.$store.getters['user/userInfo'].FirstName
        this.info.lname = this.$store.getters['user/userInfo'].LastName
        this.info.email = this.$store.getters['user/userInfo'].Email
        this.isShowSuccess = false
      }
    }
  }
</script>

<style scoped>
.colcenter{
  text-align: center;
}
  .row{
    margin: 20px;
  }

#modalContactUsFreeDiagnostic .modal-lg {
   max-width: 60% !important;
}
#modalContactUsFreeDiagnostic .modal-title {
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/landings/MDataDiagnostic.vue